import { render, staticRenderFns } from "./QuoteSection.vue?vue&type=template&id=72a369ff&scoped=true"
import script from "./QuoteSection.vue?vue&type=script&lang=js"
export * from "./QuoteSection.vue?vue&type=script&lang=js"
import style0 from "./QuoteSection.vue?vue&type=style&index=0&id=72a369ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a369ff",
  null
  
)

export default component.exports